import React, { useContext } from 'react';
import slugify from 'slugify';
import classnames from 'classnames';
import { compact } from 'lodash';
import { Link } from 'gatsby';
import { ArrowRight } from 'react-feather';
import path from 'path-browserify';

import { SchoolFragment, LocationPanelFragment } from '../../../../graphql.schema';
import Map from '../../Map';
import { RichTextField } from '../../RichTextField/RichTextField';
import StrapiButton from '../../StrapiLink/StrapiButton';
import { PageContext } from '../../PageContext';
import { addTrailingSlash } from '../../../lib/helpers';

import * as styles from './strapi-location-panel.module.scss';

export type LocationPanelProps = LocationPanelFragment & {
  schools?: SchoolFragment[];
};

export const StrapiLocationPanel = ({ title, text, optional_link, map, schools }: LocationPanelProps) => {
  const context = useContext(PageContext);
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <h4 className={classnames('title is-4', styles.title)}>{title}</h4>
        {text && <RichTextField content={`<p class="text-1 mb-5">${text}</p>`} />}
        {optional_link && <StrapiButton type="secondary" {...optional_link} />}
        {schools && (
          <div className={styles.schoolsListWrapper}>
            {schools.map(({ name, slug }) => (
              <Link
                className="is-flex is-align-items-center has-text-weight-bold mb-3"
                key={name.replace(/\s+/g, '-').toLowerCase()}
                to={addTrailingSlash(path.join(context.pathPrefixes.schools, slug ?? slugify(name, { lower: true, strict: true })))}
              >
                {name}<ArrowRight size={16} className="black-4 ml-1" />
              </Link>
            ))}
          </div>
        )}
      </div>

      <div className={styles.map}>
        {map ? (
          <Map
            markers={compact(
              map.markers?.map((map) => ({
                ...map,
                popUpHtml: map?.mapMarker?.mapLocation?.pop_up_html ?? map?.mapLocation?.pop_up_html ?? '',
                lat: map?.mapMarker?.mapLocation?.latitude ?? map?.mapLocation?.latitude ?? 0,
                lng: map?.mapMarker?.mapLocation?.longitude ?? map?.mapLocation?.longitude ?? 0,
              })),
            )}
            width={'100%'}
            height={'100%'}
            defaultZoom={map.defaultZoom}
          />
        ) : null}
      </div>
    </div>
  );
};
